import styled from "styled-components";

export const CMHeadingContainer = styled.div((props) => ({
  flexDirection: "row",
  paddingTop: 33,

  "& h3": {
    margin: 0,
    paddingRight: 25,
    paddingLeft: 18,
    fontFamily: props.theme.fontFamilies.workSans,
  },
  "& h5": {
    margin: 0,
    paddingRight: 25,
    paddingLeft: 18,
    fontFamily: props.theme.fontFamilies.jost,
    fontWeight: "normal",
  },

  [`@media${props.theme.breakpoints.lg}`]: {
    flexDirection: "column",
  },
  "& headingTop": {
    paddingTop: 33,
  },
  [`@media${props.theme.breakpoints.xs}`]: {
    flexDirection: "column",
  },
}));
export const CMOffer = styled.div((props) => ({
  flexDirection: "row",
  justifyContent: "left",
  paddingLeft: 18,

  "& Button": {
    height: 76,
    width: 278,
    fontWeight: "normal",
    fontFamily: props.theme.fontFamilies.jost,
    fontSize: 16,
    textAlign: "left",
    paddingLeft: 27,
    borderColor: "#707070",
    color: "#707070",

    "& span": {
      color: "#707070",
      paddingLeft: "120px",

      "& svg": {
        position: "absolute",
      },
      "& svg:hover": {
        color: "#FFFF",
      },
    },
    "&:hover": {
      color: "#FFFFFF",
      "& span": {
        color: "#FFFFFF",
      },
    },
  },

  [`@media ${props.theme.breakpoints.lg}`]: {
    flexDirection: "column",
    alignItems: "center",
    "& span": {
      right: "15% !important",
    },
  },
  [`@media ${props.theme.breakpoints.xs}`]: {
    flexDirection: "column",
    alignItems: "center",
    "& span": {
      right: "15% !important",
    },
  },
}));

export const CMBox = styled.div((props) => ({
  display: "flex",
  flexDirection: "column",
}));
export const CMImageBox = styled.div((props) => ({
  display: "flex",
  flexDirection: "row",
  paddingTop: 28,
  paddingBottom: 37,
}));

export const CMImage = styled.div((props) => ({
  display: "flex",
  flexDirection: "row",
  borderRadius: "13%",
  alignItems: "center",
  justifyContent: "center",
  border: "solid 1px #707070",
  backgroundColor: "#FFFFFF",
  height: 76,
  width: 127,
  marginLeft: 18,
  cursor: "pointer",
  "& img": {
    width: "75%",
  },

  [`@media ${props.theme.breakpoints.lg}`]: {
    top: "15px",
    "& img": {
      width: "100%",
    },
  },

  [`@media ${props.theme.breakpoints.xs}`]: {},
}));
